// Premium curated color palettes inspired by Coolors.co

export const oceanTeal = [
  '#f0fdfa', // 0: lighter
  '#ccfbf1', // 1: 100
  '#99f6e4', // 2: 200
  '#5eead4', // 3: light
  '#2dd4bf', // 4: 400
  '#0d9488', // 5: main
  '#0f766e', // 6: dark
  '#115e59', // 7: 700
  '#134e4a', // 8: darker
  '#0f3a38'  // 9: 900
];

export const royalIndigo = [
  '#e0e7ff', // 0: lighter
  '#c7d2fe', // 1: 100
  '#a5b4fc', // 2: 200
  '#818cf8', // 3: light
  '#6366f1', // 4: 400
  '#4f46e5', // 5: main
  '#4338ca', // 6: dark
  '#3730a3', // 7: 700
  '#312e81', // 8: darker
  '#1e1b4b'  // 9: 900
];

export const mintGreen = [
  '#ecfdf5', // 0: lighter
  '#d1fae5', // 1: 100
  '#a7f3d0', // 2: 200
  '#6ee7b7', // 3: light
  '#34d399', // 4: 400
  '#059669', // 5: main
  '#047857', // 6: dark
  '#065f46', // 7: 700
  '#064e3b', // 8: darker
  '#022c22'  // 9: 900
];

export const roseCoral = [
  '#fff1f2', // 0: lighter
  '#ffe4e6', // 1: 100
  '#fecdd3', // 2: 200
  '#fda4af', // 3: light
  '#fb7185', // 4: 400
  '#f43f5e', // 5: main
  '#e11d48', // 6: dark
  '#be123c', // 7: 700
  '#9f1239', // 8: darker
  '#881337'  // 9: 900
];

export const sunsetOrange = [
  '#fff7ed', // 0: lighter
  '#ffedd5', // 1: 100
  '#fed7aa', // 2: 200
  '#fdba74', // 3: light
  '#f97316', // 4: 400
  '#ea580c', // 5: main
  '#ca5a04', // 6: dark
  '#b44b00', // 7: 700
  '#9a3412', // 8: darker
  '#7c2d12'  // 9: 900
];

export const midnightSlate = [
  '#f8fafc', // 0: lighter
  '#f1f5f9', // 1: 100
  '#e2e8f0', // 2: 200
  '#cbd5e1', // 3: light
  '#94a3b8', // 4: 400
  '#475569', // 5: main
  '#334155', // 6: dark
  '#1e293b', // 7: 700
  '#0f172a', // 8: darker
  '#020617'  // 9: 900
];

export const curatedPalettes = {
  'ocean-teal': oceanTeal,
  'royal-indigo': royalIndigo,
  'mint-green': mintGreen,
  'rose-coral': roseCoral,
  'sunset-orange': sunsetOrange,
  'midnight-slate': midnightSlate
};

export const themeBackgrounds = {
  'ocean-teal': {
    lightBg: '#e6f5f3', // rich soft teal page background
    lightPaper: '#ffffff',
    darkBg: '#071513', // rich deep dark teal page background
    darkPaper: '#0d2421' // dark teal card/paper
  },
  'royal-indigo': {
    lightBg: '#ecf0fb', // rich soft indigo page background
    lightPaper: '#ffffff',
    darkBg: '#060714', // rich deep dark indigo page background
    darkPaper: '#0c0e24' // dark indigo card/paper
  },
  'mint-green': {
    lightBg: '#e9f7f0', // rich soft mint page background
    lightPaper: '#ffffff',
    darkBg: '#04110c', // rich deep dark mint page background
    darkPaper: '#092218' // dark mint card/paper
  },
  'rose-coral': {
    lightBg: '#fff0f2', // rich soft rose page background
    lightPaper: '#ffffff',
    darkBg: '#120406', // rich deep dark rose page background
    darkPaper: '#220c10' // dark rose card/paper
  },
  'sunset-orange': {
    lightBg: '#fff4ec', // rich soft orange page background
    lightPaper: '#ffffff',
    darkBg: '#130904', // rich deep dark orange page background
    darkPaper: '#24140a' // dark orange card/paper
  },
  'midnight-slate': {
    lightBg: '#f1f5f9', // rich slate light page background
    lightPaper: '#ffffff',
    darkBg: '#090d16', // rich slate dark page background
    darkPaper: '#121824' // dark slate card/paper
  }
};
